import type { LinkProps } from '@mui/material/Link';

import { forwardRef } from 'react';
import { mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/components/router';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export const NEXMAIL_TEXT_GRADIENT =
  'linear-gradient(90deg, #00A76F 0%, #0EA5E9 55%, #3B82F6 100%)';

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
  isMini?: boolean;
};

export const Logo = forwardRef<HTMLAnchorElement, LogoProps>((props, ref) => {
  const { className, href = '/', isSingle = false, isMini = false, disabled, sx, ...other } = props;

  const iconOnly = isSingle || isMini;
  const src = iconOnly ? '/logo/logo-icon-gradient.svg' : '/logo/logo-full-gradient.svg';
  const height = isMini ? 32 : 40;
  const width = iconOnly ? height : (height * 420) / 128;

  return (
    <LogoRoot
      ref={ref}
      component={RouterLink}
      href={href}
      aria-label="nexmail"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        () => ({
          display: 'inline-flex',
          alignItems: 'center',
          height,
          ...(disabled && { pointerEvents: 'none' }),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Box
        component="img"
        alt="nexmail"
        src={src}
        sx={{ height, width, flexShrink: 0 }}
      />
    </LogoRoot>
  );
});

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
